import { render, staticRenderFns } from "./botaoExcluir.vue?vue&type=template&id=cb2b4d4c"
import script from "./botaoExcluir.vue?vue&type=script&lang=ts"
export * from "./botaoExcluir.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports